// src/components/PP2Exams.js
import React from 'react';

import ExamsList from './ExamsListPerYear';

const PrimaryHolidayAssignments = ({ isLoggedIn, clearToken }) => {
    const items = [
        { name: '2026 PRIMARY HOLIDAY ASSIGNMENTS', year: 2026, bgColor: 'rgba(0, 0, 0, 0.2)', textColor: 'rgb(0, 0, 0)', path: "primary", value: "holiday/assignments" },
        { name: '2025 PRIMARY HOLIDAY ASSIGNMENTS', year: 2025, bgColor: 'rgba(0, 0, 0, 0.1)', textColor: 'rgb(0, 0, 0)', path: "primary", value: "holiday/assignments" },

    ];

    return (
       <>
       
        <ExamsList
           
            heading="PRIMARY HOLIDAY ASSIGNMENTS"
            items={items}
            navigateTo="/primary/holiday/assignments/downloads"
        />
       </>
    );
};

export default PrimaryHolidayAssignments;
